module.exports = __webpack_public_path__ + "img/1991_S.57a3b438.png";